<template>
  <div class="receipt-list tab-table p-2">
    <BidsTable :exclude-search-fields="['bidder_uuid']" hide-bid-creation :exclude-columns="['bidder']"/>
  </div>
</template>

<script>

  import {createNamespacedHelpers} from "vuex";
  import BidsTable from "@/modules/bids/BidsTable";

  const {mapState} = createNamespacedHelpers('customer/customerView');
  const {mapActions: bidsMapActions} = createNamespacedHelpers('bids');

  export default {
    name: "BidsList",
    components: {BidsTable},
    methods: {
      ...bidsMapActions(['updateTableSource'])
    },
    computed: {
      ...mapState({
        customer: state => state.customer,
      }),
    },
    async beforeMount() {
      await this.updateTableSource({
        source: 'customer',
        extraFilters: {customer_uuid: this.customer.uuid}
      });
    }
  }
</script>

<style lang="scss" scoped>

</style>
